// extracted by mini-css-extract-plugin
export default {"container":"QuantitySelector_container__Gp+Tq","loading":"QuantitySelector_loading__9GH2V"};